export const LARGE_RANDOM_INT_MIN = 1000000000;
// Get a random integer greater than one billion.
export const getLargeRandomInt = (): number =>
  Math.floor(Math.random() * (Number.MAX_SAFE_INTEGER - LARGE_RANDOM_INT_MIN)) +
  LARGE_RANDOM_INT_MIN;

export const isLargeRandomInt = (value: string | number): boolean =>
  Number(value) >= LARGE_RANDOM_INT_MIN;
